/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Flow_Verify_DescInputs */

const en_mk_team_flow_verify_desc = /** @type {(inputs: Mk_Team_Flow_Verify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results are checked together against the plan’s criteria. A process stopping does not make a task complete.`)
};

const id_mk_team_flow_verify_desc = /** @type {(inputs: Mk_Team_Flow_Verify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasil diuji bersama dengan kriteria pada rencana. Proses berhenti saja belum berarti tugas selesai.`)
};

/**
* | output |
* | --- |
* | "Results are checked together against the plan’s criteria. A process stopping does not make a task complete." |
*
* @param {Mk_Team_Flow_Verify_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_flow_verify_desc = /** @type {((inputs?: Mk_Team_Flow_Verify_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Flow_Verify_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_flow_verify_desc(inputs)
	return en_mk_team_flow_verify_desc(inputs)
});